<template>
  <div :class="$options.name">
    <v-combobox
      v-if="checkPermissions(['tag-create'])"
      v-model="selected"
      multiple
      clearable
      chips
      hide-selected
      label="Теги"
      item-text="name"
      menu-props="auto"
      :items="items"
      @update:search-input="searchInput = $event"
      @input="$emit('onInput', $event)"
    >
      <template v-slot:selection="{ attrs, item, parent, selected }">
        <v-chip
          v-bind="attrs"
          color="lighten-3"
          :input-value="selected"
          label
        >
          <span class="pr-2">
            {{ item.name ? item.name : item }}
          </span>

          <v-icon
            small
            @click="parent.selectItem(item)"
          >
            $delete
          </v-icon>
        </v-chip>
      </template>

      <template v-if="searchInput" v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Нажмите <kbd>enter</kbd> чтобы добавить "<strong>{{ searchInput }}</strong>".
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>

    <v-autocomplete
      v-else-if="checkPermissions('tag-view')"
      v-model="selected"
      clearable
      multiple
      hide-selected
      label="Теги"
      item-text="name"
      no-data-text="Ничего не найдено"
      menu-props="auto"
      :items="items"
    >
      <template v-slot:selection="{ attrs, item, parent, selected }">
        <v-chip
          v-bind="attrs"
          color="lighten-3"
          :input-value="selected"
          label
        >
          <span class="pr-2">
            {{ item.name ? item.name : item }}
          </span>
          <v-icon
            small
            @click="parent.selectItem(item)"
          >
            $delete
          </v-icon>
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  name: 'tags-selector',

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    initialSelected: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selected: this.initialSelected || [],
      searchInput: '',
    };
  },

  methods: {
    ...mapActions(['checkPermissions']),
  },
};

</script>
